import { render, staticRenderFns } from "./OptionEdit.vue?vue&type=template&id=497799c8"
import script from "./OptionEdit.vue?vue&type=script&lang=js"
export * from "./OptionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports